export function snackbarActive(snackbarData) {
  return {
    type: "SNACKBARACTIVE",
    snackbarData,
  };
}
